<section class="business-account-dialog custom-scrollbar">
  <!-- dialog header -->
  <div class="business-account-dialog__header">
    <!-- title -->
    <h4 class="business-account-dialog__title">
      {{ 'global.businessAccount' | translate }}
    </h4>
    <!-- close button -->
    <button (click)="close()">
      <i class="iconsax business-account-dialog__icon" icon-name="x"></i>
    </button>
  </div>
  <div class="business-account-dialog__top">
    <!-- title -->
    <p class="business-account-dialog__top-title">
      {{ 'global.byHavingBusinessAccount' | translate }}
      <span class="business-account-dialog__top-subtitle">{{
        'global.andUseItForOneMonth' | translate
      }}</span>
    </p>
    <ul>
      <li class="business-account-dialog__li">
        <span class="business-account-dialog__li-title">{{
          'global.shareProducts' | translate
        }}</span>
        <span class="business-account-dialog__li-subtitle">{{
          'global.yourProductsOnOurSite' | translate
        }}</span>
      </li>

      <li class="business-account-dialog__li">
        <span class="business-account-dialog__li-title">{{
          'global.exclusiveWebsite' | translate
        }}</span>
        <span class="business-account-dialog__li-subtitle">{{
          'global.youCanPlaceExclusiveWebsite' | translate
        }}</span>
      </li>
      <li class="business-account-dialog__li">
        <span class="business-account-dialog__li-title">{{
          'global.artificialIntelligence' | translate
        }}</span>
        <span class="business-account-dialog__li-subtitle">{{
          'global.youCanUseArtificialIntelligence' | translate
        }}</span>
      </li>

      <li class="business-account-dialog__li">
        <span class="business-account-dialog__li-title">{{
          'global.holdingAnAuction' | translate
        }}</span>
        <span class="business-account-dialog__li-subtitle">{{
          'global.takeAdvantageOfTheseBenefits' | translate
        }}</span>
      </li>
      <li class="business-account-dialog__li">
        <span class="business-account-dialog__li-title">{{
          'global.participateInTenders' | translate
        }}</span>
        <span class="business-account-dialog__li-subtitle">{{
          'global.youCanPutYourProductsUpForTenders' | translate
        }}</span>
      </li>
      <li class="business-account-dialog__li">
        <span class="business-account-dialog__li-title">{{
          'global.quickOrders' | translate
        }}</span>
        <span class="business-account-dialog__li-subtitle">{{
          'global.youCanPlaceAsManyQuickOrders' | translate
        }}</span>
      </li>
    </ul>
  </div>
  <!-- submit button -->
  <div class="business-account-dialog__submit">
    <pwj-button
      class="submit-btn"
      icon="chevron-right"
      size="large"
      [rotateIconInRtl]="true"
      [iconReversePosition]="true"
      variant="primary"
      (click)="confirm()"
      >{{ 'global.businessAccount' | translate }}</pwj-button
    >
  </div>
</section>
